import { objectToCamelCase } from '../utils'
import api from './api'

export default class ImpactStory {
  static api = api.create(ImpactStory)

  static REQUEST_STORY = 'REQUEST_STORY'
  static CONTRIBUTION_STORY = 'CONTRIBUTION_STORY'

  constructor(json) {
    Object.assign(this, { ...json })
  }

  static create(opts) {
    return new ImpactStory(opts)
  }

  static fromAPI(json) {
    if (json) {
      return new ImpactStory(objectToCamelCase(json))
    } else {
      return null
    }
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof ImpactStory)) {
      throw Error(`${name} must be an instance of the ImpactStory class.`)
    }
  }
}
